'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sendVisitorEmailAddress = sendVisitorEmailAddress;

var _noAuthApiClient = require('../http/noAuthApiClient');

var _noAuthApiClient2 = _interopRequireDefault(_noAuthApiClient);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function sendVisitorEmailAddress(_ref) {
  var channel = _ref.channel,
      email = _ref.email,
      sessionId = _ref.sessionId;

  return _noAuthApiClient2.default.post('livechat/v1/visitor/public', {
    query: { channel: channel, email: email, sessionId: sessionId }
  });
}


//////////////////
// WEBPACK FOOTER
// ./js/email-capture/EmailCaptureClient.js
// module id = 519
// module chunks = 2 3